import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { clientApi } from '../../configuration';

type PutExerciseLearningOutcomesParams = {
  courseId: number;
  learningOutcomes: any;
};

const { useUpdate: useUpdateLearningOutcomes } = getCRUDHooks({
  entityName: 'learning-outcomes',
  update: ({ courseId, learningOutcomes }: PutExerciseLearningOutcomesParams) =>
    clientApi
      .getOCClient()
      .helpers.assessment.exercises.updateLearningOutcomes(courseId, learningOutcomes),
});

export default useUpdateLearningOutcomes;
